import React, { useState } from "react";
import "../components/contact.css";
import image1 from "../images/together-office.jpg";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Footer from "./Footer";

const Contactpage = () => {
  // ✅ State to hold user input
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [userSubject, setUserSubject] = useState("");
  const [userMessage, setUserMessage] = useState("");

  // ✅ Your WhatsApp number (change this)
  const whatsappNumber = "94771234567";

  // ✅ Function to handle WhatsApp send
  const handleWhatsAppSubmit = (e) => {
    e.preventDefault(); // prevent normal form submit

    const text = `Hello! 👋%0AYou have a new contact form message.%0A%0A*Name:* ${userName}%0A*Email:* ${userEmail}%0A*Phone:* ${userPhone}%0A*Subject:* ${userSubject}%0A*Message:* ${userMessage}`;
    const url = `https://wa.me/${whatsappNumber}?text=${text}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {/* === HERO SECTION === */}
      <section className="contact-hero">
        <img src={image1} alt="Contact background" className="contact-image" />
        <div className="hero-overlay"></div>
        <div className="contact-content">
          <h1 className="hero-title">Contact Us</h1>
          <nav className="breadcrumb">
            <b>
              <a href="/">Home / </a>
              <span className="active text-warning"> Contact Us</span>
            </b>
          </nav>
        </div>
      </section>

      {/* === WHATSAPP BUTTON === */}
      <div className="contact-button-section">
        <a
          href="https://wa.me/94771234567"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-btn"
        >
          <i className="fa-brands fa-whatsapp"></i> Chat on WhatsApp
        </a>
      </div>

      {/* === CONTACT FORM + MAP === */}
      <section className="contact-main">
        <div className="map-container">
          <iframe
            title="Company Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d126813.123456789!2d79.6682!3d9.6615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3afe6a8f5c123456%3A0xabcdef1234567890!2sJaffna%2C%20Sri%20Lanka!5e0!3m2!1sen!2slk!4v1709112345678"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="contact-form">
          <h5>Get In Touch</h5>
          <h2>We’d Love To Hear From You</h2>

          <form onSubmit={handleWhatsAppSubmit}>
            <div className="form-row">
              <div className="input-icon">
                <i className="fa-solid fa-user"></i>
                <input
                  type="text"
                  placeholder="Your Name"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  required
                />
              </div>
              <div className="input-icon">
                <i className="fa-solid fa-envelope"></i>
                <input
                  type="email"
                  placeholder="Email Address"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="input-icon">
              <i className="fa-solid fa-phone"></i>
              <input
                type="text"
                placeholder="Phone Number"
                value={userPhone}
                onChange={(e) => setUserPhone(e.target.value)}
                required
              />
            </div>

            <div className="input-icon">
              <i className="fa-solid fa-pencil"></i>
              <input
                type="text"
                placeholder="Subject"
                value={userSubject}
                onChange={(e) => setUserSubject(e.target.value)}
                required
              />
            </div>

            <div className="input-icon">
              <i className="fa-solid fa-message"></i>
              <textarea
                placeholder="Your Message"
                rows="6"
                value={userMessage}
                onChange={(e) => setUserMessage(e.target.value)}
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">
              Send Message <i className="fa-solid fa-paper-plane"></i>
            </button>
          </form>
        </div>
      </section>

      {/* 📱 WhatsApp Footer Section */}
      <div className="whatsapp-wrapper d-flex justify-content-center">
        <div className="whatsapp-section text-center py-5 px-4">
          <h3 className="fw-bold mb-3 text-white">
            Chat with Us on WhatsApp <br /> Get Instant Support
          </h3>
          <div className="d-flex justify-content-center">
            <a
              href="https://wa.me/94771234567"
              target="_blank"
              rel="noopener noreferrer"
              className="btn whatsapp-btn fw-bold px-4 py-2 d-flex align-items-center gap-2"
            >
              <i className="fa-brands fa-whatsapp"></i>
              Chat Now
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Contactpage;
